import React, { useCallback, useState } from "react";
import { useDialogState } from "../../../primitives";
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { Editor, Element, Transforms } from "slate";
import { InsertPreconfiguredBlockDialog, PreconfiguredBlockGrandType } from "./InsertPreconfiguredBlockDialog";
import { generateCode } from "../common";

const generatePreconfiguredBlock = (grandType: PreconfiguredBlockGrandType, blockType: string, configuration: any) => {
  const fieldsCodes: string[] = (configuration?.fields || [])
    .map((f: string) => f.split(";"))
    .map(([code]: string[]) => code.trim());

  const bits = grandType === "custom_fields_block"
    ? {
      fieldsCodes: fieldsCodes,
      fields: Object.entries(configuration.defaults || {}).reduce<any>((r,[k,v]) => {
        r[k] = { label: k, value: v };
        return r;
      }, {}),
    } : {
      rows: [{ _id: generateCode() }],
    };

  return {
    _id: generateCode(),
    type: grandType,
    render_block_type: blockType,
    custom_settings: ["render_block_type"],
    children: [{ text: "" }],
    ...bits,
  }
}

export const insertPreconfiguredBlock = (
  editor: Editor,
  grandType: PreconfiguredBlockGrandType,
  blockType: string,
  configuration: any) => {

  const block = generatePreconfiguredBlock(grandType, blockType, configuration);
  Transforms.insertNodes(editor, block)
}

interface EditingContext {
    editor: Editor;
}

export const usePreconfiguredBlocksPlugin = (): EditorPlugin => {
    const [editingContext, setEditingContext] = useState<EditingContext | null>(null);
    const insertDialogState = useDialogState();


    const startEdit = useCallback(
        (editor: Editor, e?: Element) => {
          setEditingContext({ editor });
          insertDialogState.open();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

    const dialog = insertDialogState.isOpen
      ? (
        <InsertPreconfiguredBlockDialog
          {...insertDialogState}
          doInsert={(gt, t, c) => !!editingContext?.editor && insertPreconfiguredBlock(editingContext.editor, gt, t, c)}
            />)
      : null;

    return {
        key: "preconfigured-blocks",
        dialogs: dialog,
        commands: [{
            // isAvailable: () => !!mediaLib.isAvailable,
            name: "insert-preconfigured-block",
            invoke: editor => startEdit(editor),
            menu: { section: "insert-item", label: "Preconfigured block", label_id: "powerdoc.plugins.preconfigured_blocks.title" },
        },
      ],
    };
}
